// import "./crouselImage.css";
// import React, { useRef } from "react";
// import { toPng } from "html-to-image";

// export default function CrouselNewsCard({

// }) {
//   const cardRef = useRef(null);

//   const downloadImage = async () => {
//     if (!cardRef.current) {
//       console.error("Card reference is null");
//       return;
//     }

//     try {
//       const dataUrl = await toPng(cardRef.current, {
//         cacheBust: true,
//         pixelRatio: 2,
//         width: 1080,
//         height: 1350,
//         canvasWidth: 1080,
//         canvasHeight: 1350,
//       });

//       const link = document.createElement("a");
//       link.download = "news-card.png";
//       link.href = dataUrl;
//       link.click();
//     } catch (error) {
//       console.error("Download Error:", error);
//     }
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <div ref={cardRef} className="news-card">
//         {/* Background Image */}
//         <img
//           src="https://res.cloudinary.com/bsgfcooa/image/upload/v1785222207/uri_ifs___M_b233c5cb-af76-4313-905b-824fe2411e8d_naa8qn.webp"
//           alt=""
//           className="bg-image"
//           crossOrigin="anonymous"
//         />

//         {/* Transparent PNG Overlay */}
//         <img
//           src="https://res.cloudinary.com/bsgfcooa/image/upload/v1785221966/this-week-in-horti_qzkvie.png"
//           alt=""
//           className="overlay-image"
//           crossOrigin="anonymous"
//         />

//         {/* Dynamic Text */}
//         <div className="text-box">
//           दिल्ली के आम महोत्सव में देशभर की 400 से अधिक आम की किस्मों का
//           प्रदर्शन किया गया। इस आयोजन का उद्देश्य भारतीय बागवानी और आम
//           उत्पादकों को बढ़ावा देना है।
//         </div>
//       </div>

//       <button
//         onClick={downloadImage}
//         style={{
//           marginTop: 20,
//           padding: "12px 24px",
//           fontSize: 18,
//           cursor: "pointer",
//         }}
//       >
//         Download PNG
//       </button>
//     </div>
//   );
// }

import "./crouselImage.css";
import React from "react";

export default function CrouselNewsCard({ image, description }) {
  return (
    <div>
      <div className="news-card">
        {/* Background Image */}
        <img src={image} alt="" className="bg-image" crossOrigin="anonymous" />

        {/* Transparent PNG Overlay */}
        <img
          src="https://res.cloudinary.com/bsgfcooa/image/upload/v1785221966/this-week-in-horti_qzkvie.png"
          alt=""
          className="overlay-image"
          crossOrigin="anonymous"
        />

        {/* Dynamic Text */}
        <div className="text-box">{description}</div>
      </div>
    </div>
  );
}
